export default "__VITE_ASSET__DqeldeZp__"